// src/menuItems.js
import {
  BsFileEarmarkPdf,
  BsFillPeopleFill,
  BsBoundingBoxCircles,
  BsLightningFill,
  BsBoxSeam,
  BsBarChartFill,
} from "react-icons/bs";
import { TfiDashboard, TfiReceipt, TfiBag, TfiPanel } from "react-icons/tfi";

export const MENU = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: TfiDashboard,
    to: "/dashboard",
    roles: [1, 2, 4], // not visible for lvl 5
  },
  {
    key: "quotation",
    label: "Quotation",
    icon: TfiReceipt,
    roles: [1, 4], // originally user_lvl !== 2 && !== 3 && !== 5
    children: [
      {
        key: "quotation.add",
        label: "Add Quotation",
        to: "/quotation/add",
        roles: [1, 4],
      },
      {
        key: "quotation.search",
        label: "Search Quotation",
        to: "/quotation",
        roles: [1, 4],
      },
      {
        key: "quotation.customers",
        label: "Customer List",
        to: "/quotation/customers",
        roles: [1, 4],
      },
    ],
  },
  {
    key: "jobsheet",
    label: "Jobsheet",
    icon: TfiPanel,
    roles: [1, 4],
    children: [
      {
        key: "jobsheet.add",
        label: "Add Jobsheet",
        to: "/jobsheet/add",
        roles: [1, 4],
      },
      {
        key: "jobsheet.search",
        label: "Search Jobsheet",
        to: "/jobsheet",
        roles: [1, 4],
      },
      {
        key: "jobsheet.align",
        label: "Align PDF",
        to: "/jobsheet/align",
        roles: [1],
      },
      {
        key: "jobsheet.material",
        label: "Material",
        to: "/jobsheet/material",
        roles: [1, 4],
      },
      {
        key: "jobsheet.operator-qc",
        label: "Operator & QC",
        to: "/jobsheet/operator-qc",
        roles: [1, 4],
      },
    ],
  },
  {
    key: "reporting",
    label: "Reporting",
    icon: BsBarChartFill,
    roles: [1, 4],
    children: [
      {
        key: "reporting.production",
        label: "Production Report",
        to: "/jobsheet/report",
        roles: [1, 4],
      },
      {
        key: "reporting.client",
        label: "Client Report",
        to: "/reporting/client",
        roles: [1, 4],
      },
      {
        key: "reporting.yearly-chart",
        label: "Yearly Chart",
        to: "/reporting/yearly-chart",
        roles: [1, 4],
      },
    ],
  },
  {
    key: "orders",
    label: "Orders",
    icon: TfiBag,
    roles: [1, 2, 4],
    children: [
      {
        key: "orders.list",
        label: "Master Order",
        to: "/orderlist",
        roles: [1, ,2, 4],
      },
      {
        key: "orders.new",
        label: "New Order",
        to: "/addOrder",
        roles: [1, 4],
      },
      {
        key: "orders.production_assignment",
        label: "Production Assignment",
        to: "/orders/production-assignment",
        roles: [1, 4],
      },
      {
        key: "orders.qc",
        label: "QC Checking",
        to: "/qc_checking",
        roles: [1, 2, 4],
      },
      {
        key: "orders.qc_shipment",
        label: "QC Shipment List",
        to: "/qc_shipment_list",
        roles: [1, 2, 4],
      },
      {
        key: "orders.finished_goods",
        label: "Finished Goods",
        to: "/finished_goods",
        roles: [1, 2, 4],
      },
    ],
  },
  {
    key: "documents",
    label: "Documents",
    icon: BsFileEarmarkPdf,
    roles: [1, 2, 3, 4, 5],
    children: [
      { key: "docs.msds", label: "MSDS", to: "/msds", roles: [1, 2, 3, 4, 5] },
      { key: "docs.icp", label: "ICP", to: "/icp", roles: [1, 2, 3, 4, 5] },
      { key: "docs.specs", label: "Specs", to: "/specs", roles: [1, 2, 3, 4, 5] },
      { key: "docs.delete", label: "Delete Documents", action: true, roles: [1] },
    ],
  },
  {
    key: "diecut",
    label: "Diecut",
    icon: BsBoundingBoxCircles,
    roles: [1, 2, 4],
    children: [
      {
        key: "diecut.add",
        label: "Add Diecut",
        to: "/add_diecut",
        roles: [1, 4],
      },
      {
        key: "diecut.list",
        label: "Diecut List",
        to: "/diecut-list",
        roles: [1, 2, 4],
      },
    ],
  },
  {
    key: "production",
    label: "Production",
    icon: BsLightningFill,
    roles: [1, 2, 4, 6, 7],
    children: [
      {
        key: "prod.req",
        label: "Request Material",
        to: "/request_mat",
        roles: [1, 2, 3, 4, 5, 6, 7],
      },
      {
        key: "prod.reqList",
        label: "Request Material List",
        to: "/request-list",
        roles: [1, 2, 4],
      },
      {
        key: "prod.requestFG",
        label: "Request Ribbon / Finished Goods",
        to: "/request-ribbon-fg",
        roles: [1, 2, 4, 7],
      },
    ],
  },
  {
    key: "store",
    label: "Store",
    icon: BsBoxSeam,
    roles: [1, 3, 4, 5],
    children: [
      {
        key: "store.current",
        label: "Show Current Stocks",
        to: "/currentstock",
        roles: [1, 4, 5],
      },
      {
        key: "store.group",
        label: "New Material Group",
        to: "/addstoregroup",
        roles: [1, 5],
      },
      {
        key: "store.loc",
        label: "New Material Location",
        to: "/addlocation",
        roles: [1, 5],
      },
      {
        key: "store.newMat",
        label: "New Material",
        to: "/addmaterial",
        roles: [1, 5],
      },
      {
        key: "store.mats",
        label: "Material List",
        to: "/materials",
        roles: [1, 5],
      },
      {
        key: "store.in",
        label: "Stock In",
        to: "/stockin",
        roles: [1, 5],
      },
      {
        key: "store.out",
        label: "Stock Out",
        to: "/stockout",
        roles: [1, 5],
      },
      {
        key: "store.tx",
        label: "Transaction Record",
        to: "/transactions",
        roles: [1, 4, 5],
      },
      {
        key: "store.reports",
        label: "Monthly Report",
        to: "/reports",
        roles: [1, 5],
      },
      {
        key: "store.approve",
        label: "Approve Material",
        to: "/approve_mat",
        roles: [1, 5],
      },
      {
        key: "store.approve_stockin",
        label: "Approve Stock In",
        to: "/approve_stockin",
        roles: [1, 5],
      },
    ],
  },
  {
    key: "user",
    label: "Users",
    icon: BsFillPeopleFill,
    roles: [1], // admin only
    children: [
      {
        key: "users.list",
        label: "User List",
        to: "/users",
        roles: [1],
      },
      {
        key: "users.level",
        label: "User Levels",
        to: "/user_level",
        roles: [1],
      },
      {
        key: "users.permissions",
        label: "Page Permissions",
        to: "/page_permissions",
        roles: [1],
      },
      {
        key: "users.form_numbers",
        label: "Form Numbers",
        to: "/form_numbers",
        roles: [1],
      },
    ],
  },
];

// ---- Feature permissions (not sidebar pages — widgets/bells/etc.) ----
export const EXTRA_PERMISSIONS = [
  {
    sectionKey: "notifications",
    sectionLabel: "Notifications",
    pages: [
      { key: "notifications.stock_alerts", label: "Stock Alert Bell" },
    ],
  },
];

// ---- Build a fast path→roles lookup (normalized paths) ----
const normalize = (p) => (p === "/" ? "/" : (p || "").replace(/\/+$/, "")); // remove trailing slash

export const ROUTE_ROLES = (() => {
  const map = {};
  const walk = (items) => {
    items.forEach((it) => {
      if (it.to) map[normalize(it.to)] = it.roles || [];
      if (it.children) walk(it.children);
    });
  };
  walk(MENU);
  return map;
})();
